(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elumii-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBar(bar) {
    if (!bar || bar.dataset.anncReady === 'true') return;
    var items = bar.querySelectorAll('[data-annc-item]');
    if (items.length <= 1) {
      bar.dataset.anncReady = 'true';
      return;
    }

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      bar.dataset.anncReady = 'true';
      return;
    }

    var speedSeconds = parseFloat(bar.style.getPropertyValue('--annc-speed')) || 4;
    var intervalMs = Math.max(2000, speedSeconds * 1000);
    var current = 0;
    var timer = null;

    function show(next) {
      items[current].classList.remove('is-active');
      current = next;
      items[current].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      timer = window.setInterval(function () {
        show((current + 1) % items.length);
      }, intervalMs);
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    bar.dataset.anncReady = 'true';
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-elumii-annc]').forEach(initBar);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target.querySelector('[data-elumii-annc]');
    if (bar) {
      bar.dataset.anncReady = 'false';
      initBar(bar);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elumii-feature-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  function revealRows(root) {
    var scope = root || document;
    var rows = scope.querySelectorAll('.elumii-feature__row[data-reveal]');
    if (!rows.length) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      rows.forEach(function (row) { row.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    rows.forEach(function (row) { observer.observe(row); });
  }

  if (document.readyState !== 'loading') {
    revealRows();
  } else {
    document.addEventListener('DOMContentLoaded', function () { revealRows(); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    revealRows(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elumii-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-elumii-satc]');
  if (!bar) return;

  var mainBtn =
    document.querySelector('.product-form__submit') ||
    document.querySelector('product-form button[name="add"]') ||
    document.querySelector('form[action*="/cart/add"] [type="submit"]');

  var addBtn = bar.querySelector('[data-satc-add]');

  // Delegate the add-to-cart to Dawn's main form button (keeps variant + cart drawer logic)
  if (addBtn && mainBtn) {
    addBtn.addEventListener('click', function () {
      if (mainBtn.hasAttribute('disabled')) return;
      mainBtn.click();
    });
  }

  // Show the bar only once the main button has scrolled above the viewport
  function setShown(show) {
    if (show) bar.classList.add('is-visible');
    else bar.classList.remove('is-visible');
  }

  if (mainBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          setShown(!e.isIntersecting && e.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    io.observe(mainBtn);
  }

  // Mirror the live price + availability from Dawn's price/button as the variant changes
  var satcPrice = bar.querySelector('[data-satc-price]');
  var satcLabel = bar.querySelector('[data-satc-label]');
  var mainPrice = document.querySelector('.product__info-container .price') ||
    document.querySelector('.product .price');

  function syncPrice() {
    if (!mainPrice || !satcPrice) return;
    var sale = mainPrice.querySelector('.price-item--sale');
    var reg = mainPrice.querySelector('.price-item--regular');
    var txt = '';
    if (sale && sale.offsetParent !== null && sale.textContent.trim()) {
      txt = sale.textContent;
    } else if (reg && reg.textContent.trim()) {
      txt = reg.textContent;
    }
    txt = txt.replace(/\s+/g, ' ').trim();
    if (txt) satcPrice.textContent = txt;
  }

  function syncAvail() {
    if (!addBtn || !mainBtn) return;
    var disabled = mainBtn.hasAttribute('disabled');
    if (disabled) {
      addBtn.setAttribute('disabled', '');
      if (satcLabel) satcLabel.textContent = 'Rupture de stock';
    } else {
      addBtn.removeAttribute('disabled');
    }
  }

  if (mainPrice) {
    syncPrice();
    new MutationObserver(function () {
      syncPrice();
      syncAvail();
    }).observe(mainPrice, { subtree: true, childList: true, characterData: true });
  }
  if (mainBtn) {
    new MutationObserver(syncAvail).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
